import { useCallback } from 'react'
import { type PartnerPickDeviceDatum } from 'domains/partner-pick-devices/types/partnerPickDevices.types'
import { useDomainIntl } from 'domains/partner-pick-devices/utils/domain/intl'
import { NotificationsContext } from 'legacy/contexts/notifications/NotificationsContext'
import { useRequiredContext } from 'legacy/contexts/utils'

export const usePartnerPickDevicesNotification = () => {
  const { notify: _notify } = useRequiredContext(NotificationsContext)
  const intl = useDomainIntl()

  const notify = useCallback(
    (partnerPickDevice: PartnerPickDeviceDatum, newAccount: boolean) => {
      const message = intl.formatMessage(
        {
          id: newAccount
            ? 'partnerPickDevicesDomain.notification.create'
            : 'partnerPickDevicesDomain.notification.update',
        },
        {
          device: `${partnerPickDevice.firstName} ${partnerPickDevice.lastName}`,
        }
      )

      _notify(message, 'modern')
    },
    [_notify, intl]
  )

  return {
    notify,
  }
}
